<template>
  <div
    :style="{width}"
    class="pagoda-drag-box"
    ref="dragBox"
  >
    <slot></slot>
    <span
      @mousedown="mouseDown"
      class="pagoda-drag-bar"
      ref="dragBar"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'DragBox',
  props: {
    minWidth: {
      type: String,
      default: '200px'
    }
  },
  data() {
    return {
      width: this.minWidth
    }
  },
  methods: {
    mouseDown(e) {
      const startX = e.clientX
      const boxWidth = this.$refs.dragBox.offsetWidth
      let changeWidth

      document.onmousemove = e => {
        e.preventDefault()

        let distX = Math.abs(e.clientX - startX)

        changeWidth = e.clientX > startX ? boxWidth + distX : boxWidth - distX
        this.width =
          parseInt(changeWidth) > parseInt(this.minWidth)
            ? `${changeWidth}px`
            : `${this.minWidth}px`
      }

      document.onmouseup = () => {
        document.onmousemove = null
        this.$emit('drag-end')
      }
    }
  }
}
</script>
